import * as React from 'react';

export const SemanticUiForm: React.SFC = ({ children }) => (
  <div className="ui form">{children}</div>
);
